<script lang="ts">
    import { _ } from "svelte-i18n"
    import FormInputText from "../../widgets/Form/FormInputText.svelte"
    import { cart, checkoutData, getAsyncCartSum } from "../../../functionTools/cart"
    import ShippingDeliveryAddress from "./ShippingDeliveryAddress.svelte"
    import { maxInputLength } from "../../../../../api/hooks/config-client"
    import { spaNavigate } from "../../../functionTools/navigation"
    import { login } from "../../../functionTools/login"
    import CheckoutFooter from "./CheckoutFooter.svelte"
    import { defaultVAT } from "../../../../../api/hooks/config-client"
    import { onMount } from "svelte"
    import { cartItemToInput, trackItemsEvent } from "../../../lib/ga"

    function cartVat(): number {
        try {
            return $login ? 0 : ($checkoutData.vat ?? defaultVAT)
        } catch {
            return defaultVAT
        }
    }

    onMount(() => {
        // GA4 begin_checkout — einmal beim Einstieg in den Checkout
        try {
            if ($cart?.length) {
                trackItemsEvent(
                    "begin_checkout",
                    $cart.map(cartItemToInput),
                    cartVat()
                )
            }
        } catch {
            // Tracking darf nichts blockieren
        }
    })

    const invalidate = () => {
        $checkoutData.stepsValid = 0
    }

    $effect(() => {
        if (!$cart?.length || $login) {
            // empty cart goto start
            spaNavigate("/")
        }
    })

    let cartSum: CartSum = $state()

    $effect(() => {
        ;(async () => {
            cartSum = await getAsyncCartSum($cart)
        })()
    })
</script>

<div class="subline">{$_("checkout.order")}</div>
<h2 class="h2_nooffset">{$_("checkout.info-and-shipping")}</h2>

<form
    onsubmit={(e) => {
        e.preventDefault()

        // GA4 add_shipping_info (vor dem Weiterleiten)
        try {
            if ($cart?.length) {
                trackItemsEvent("add_shipping_info", $cart.map(cartItemToInput), cartVat(), {
                    shipping_tier: $checkoutData.deliveryAddress?.countryCode || "",
                })
            }
        } catch {
            // Tracking darf nichts blockieren
        }

        // Bei kostenlosem Warenkorb: Lieferadresse als Rechnungsadresse übernehmen und Payment überspringen
        if (cartSum?.totalGross === 0) {
            $checkoutData.sameAddress = true
            Object.keys($checkoutData.deliveryAddress).forEach((k) => {
                $checkoutData.billingAddress[k as keyof Address] = $checkoutData.deliveryAddress[k as keyof Address]
            })
            $checkoutData.stepsValid = 2
            spaNavigate("/checkout/overview")
        } else {
            $checkoutData.stepsValid = 1
            spaNavigate("/checkout/payment")
        }
    }}
>
    <section>
        <div class="section_headline">{$_("checkout.contact-info")}</div>
        <div class="row">
            <div class="col-md-12">
                <FormInputText
                    name="email"
                    label={$_("checkout.email")}
                    bind:value={$checkoutData.contact.email}
                    type="email"
                    required
                    onChange={invalidate}
                    maxlength={maxInputLength.email}
                />
            </div>
            <div class="col-md-12">
                <FormInputText
                    name="phone"
                    label={$_("checkout.phone")}
                    tooltip={$_("inquiry.phone-tooltip")}
                    bind:value={$checkoutData.contact.phone}
                    type="tel"
                    required
                    onChange={invalidate}
                    maxlength={maxInputLength.phone}
                />
            </div>
        </div>
    </section>

    <ShippingDeliveryAddress />

    <CheckoutFooter
        backlink="/"
        backtitle={$_("checkout.back-to-shop")}
        nexttitle={cartSum?.totalGross === 0 ? $_("checkout.to-overview") : $_("checkout.proceed-to-payment")}
    />
</form>
